/**
 * Route for `campaign-level-restricted-countries`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignLevelRestrictedCountriesPage } from "../features/campaign-level-restricted-countries/CampaignLevelRestrictedCountriesPage";

export const campaignLevelRestrictedCountriesRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-level-restricted-countries",
	component: CampaignLevelRestrictedCountriesPage,
});

export default campaignLevelRestrictedCountriesRoute;
